import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import ClientReviews from '../../data/reshto.json';

import userImg1 from '../../images/user/avatar-1.jpg';
import userImg2 from '../../images/user/avatar-2.jpg';
import userImg3 from '../../images/user/avatar-3.jpg';
import userImg4 from '../../images/user/avatar-4.jpg';
import userImg5 from '../../images/user/avatar-5.jpg';
import userImg6 from '../../images/user/avatar-6.jpg';
import SectionTitle from '../ui/SectionTitle';
import { motion } from 'framer-motion';

export default function FeedBack() {
    const userImages = [userImg1, userImg2, userImg3, userImg4, userImg5, userImg6];
    const [ClientReviewsData] = useState(ClientReviews);
    return (
        <>
            <motion.section initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}} viewport={{once: true}} className='section feedback-section' id='review'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col md={6} className='section-title text-center mb-5'>
                            <SectionTitle title="Food Lover Feedback"/>
                        </Col>
                    </Row>

                    <Row className='justify-content-center'>
                        <Col lg={9} xl={7} xxl={6}>
                            <Swiper
                                centeredSlides={true}
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                }}
                                pagination={{
                                    clickable: true,
                                    dynamicBullets: true,
                                    renderBullet: (index, className) => {
                                        return `
                                        <span class="${className} feedback-slider-dots">
                                            <img  src="${userImages[index]}" class="feedback-client-img"/>
                                        </span>
                                      `;
                                    },
                                }}
                                modules={[Autoplay, Pagination]}
                                className="feedback-slider"
                            >
                                {ClientReviewsData.ClientFeedBack.map((data, i) =>
                                    <SwiperSlide className='text-center px-md-4' key={i}>
                                        <motion.i initial={{opacity: 0 ,y: -50}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} custom={i} className="ri-double-quotes-l text-secondary display-2 opacity-25"></motion.i>
                                        <motion.p initial={{opacity: 0 ,y: -50}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} custom={i} className='text-muted fst-italic fs-18 mb-4 pb-2'>“<span className='fw-semibold'>{data.reviewHL}</span> {data.review}”</motion.p>
                                        <motion.h5 initial={{opacity: 0 ,y: -50}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} custom={i} className='mb-1'>{data.clientName}</motion.h5>
                                        <motion.p initial={{opacity: 0 ,y: -50}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} custom={i} className='text-muted mb-4'>{data.clientInfo}</motion.p>
                                        <motion.div initial={{opacity: 0 ,y: -50}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} custom={i} className="vr height-40 opacity-25 mb-5"></motion.div>
                                    </SwiperSlide>
                                )}
                            </Swiper>
                        </Col>
                    </Row>
                </Container>
            </motion.section>
        </>
    )
}
